import { render, staticRenderFns } from "./debian-automated-installation.vue?vue&type=template&id=dfdc98de&scoped=true&"
import script from "./debian-automated-installation.vue?vue&type=script&lang=js&"
export * from "./debian-automated-installation.vue?vue&type=script&lang=js&"
import style0 from "./debian-automated-installation.vue?vue&type=style&index=0&id=dfdc98de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdc98de",
  null
  
)

export default component.exports